/**********************************************************************************************************************
 *
 * @returns {{imagesUrl: string, baseUrl: string, clientId: string, mainDomain: string, passportKey: string}}
 **********************************************************************************************************************/
const getConfigObject = () => {
    const { IMAGE_URL, API_PROTOCOL, API_DOMAIN, API_ROUTE, MAIN_DOMAIN, PASSPORT_KEY, CLIENT_ID } = process.env;
    const origin = API_PROTOCOL + API_DOMAIN;
    return {
        baseUrl: origin + API_ROUTE,
        imagesUrl: origin + IMAGE_URL,
        mainDomain: MAIN_DOMAIN,
        passportKey: PASSPORT_KEY,
        clientId: CLIENT_ID
    };

};

/***********************************************************************************************************************
 *
 * @returns {{imagesUrl: string, baseUrl: string, clientId: string, mainDomain: string, passportKey: string}}
 **********************************************************************************************************************/
const getCustomConfig = () => {
    const { MAIN_DOMAIN, API_DOMAIN, PASSPORT_KEY, CLIENT_ID } = process.env;
    const origin = `https://${ API_DOMAIN }`;

    return {
        baseUrl: origin + '/api/v1',
        imagesUrl: origin + '/uploads/',
        mainDomain: MAIN_DOMAIN,
        passportKey: PASSPORT_KEY,
        clientId: CLIENT_ID
    };
};


/**
 *
 * @returns {{imagesUrl: string, baseUrl: string, clientId: string, mainDomain: string, passportKey: string}}
 */
const getConfig = () => {
    return process.env.NODE_ENV_TYPE ===  'custom' ? getCustomConfig() : getConfigObject();
};

export default getConfig;